
import { Component, Inject, Vue } from 'vue-property-decorator';
import GlobalState from '@/util/GlobalState';

interface NavItem {
    label: string;
    target: string;
    group: string;
}

@Component
export default class GeneralScaffold extends Vue {
    @Inject() private readonly globalState!: GlobalState;

    private drawer: boolean = true;

    public onNavigate(target: string): void {
        if (this.$route.name !== target) {
            this.$router.push({ name: target });
        }
    }

    public onLogout(): void {
        this.globalState.beginLogout();
    }

    public get navItems(): NavItem[] {
        return [
            {
                label: this.$t('navigation.home').toString(),
                target: 'home',
                group: 'home',
            },
            {
                label: this.$t('navigation.frontPageContent').toString(),
                target: 'frontPageContentForm',
                group: 'front-page-content',
            },
            {
                label: this.$t('navigation.labels').toString(),
                target: 'labelList',
                group: 'label',
            },
            {
                label: this.$t('navigation.contentPages').toString(),
                target: 'contentPageList',
                group: 'content-page',
            },
            {
                label: this.$t('navigation.navigationItems').toString(),
                target: 'navigationItemList',
                group: 'navigation-item',
            },
            {
                label: this.$t('navigation.directNavigationItems').toString(),
                target: 'directNavigationList',
                group: 'direct-navigation',
            },
            {
                label: this.$t('navigation.weeklySigns').toString(),
                target: 'weeklySignList',
                group: 'weekly-sign',
            },
            {
                label: this.$t('navigation.library-item').toString(),
                target: 'libraryItemList',
                group: 'library-item',
            },
            {
                label: this.$t('navigation.employee').toString(),
                target: 'employeeList',
                group: 'employee',
            },
            {
                label: this.$t('navigation.footer').toString(),
                target: 'footerForm',
                group: 'footer',
            },
        ];
    }

    public get webShopNavItems(): NavItem[] {
        return [
            {
                label: this.$t('navigation.shopHeader').toString(),
                target: 'shopHeaderForm',
                group: 'shopHeader',
            },
            {
                label: this.$t('navigation.order').toString(),
                target: 'orderList',
                group: 'order',
            },
            {
                label: this.$t('navigation.product-category').toString(),
                target: 'productCategoryList',
                group: 'product-category',
            },
            {
                label: this.$t('navigation.product').toString(),
                target: 'productList',
                group: 'product',
            },
            {
                label: this.$t('navigation.coupon').toString(),
                target: 'couponList',
                group: 'coupon',
            },
        ];
    }

    public get activeNavGroup(): string | null {
        if (this.$route.meta && this.$route.meta.navGroup) {
            return this.$route.meta.navGroup;
        }
        return null;
    }

    public set activeNavGroup(group: string | null) {
        if (group) {
            const item = this.navItems.find((t) => t.group === group)
                ? this.navItems.find((t) => t.group === group)
                : this.webShopNavItems.find((t) => t.group === group);
            if (item) {
                this.onNavigate(item.target);
            }
        }
    }
}
